import { useContext, useEffect, useMemo, useRef, useState } from 'react'
import TableRemuneracion from './TableRemuneracion'
import GlobalContext from '../../../../../../context/global-context'
import { BusinessAPI } from '../../../../../../api/business.api'
import { IntegrationsAPI } from '../../../../../../api/integrations.api'
import { Button } from '../../../../ui'
import CustomButton from '../../../../ui/CustomButton'
import SearchFilter from '../../../../ui/SearchFilter'
import ModalAgregarRemuneracion from './ModalCargas/ModalAgregarRemuneracion'
import ModalConectarBuk from './ModalBuk/ModalConectarBuk'
import { useIntegrationStatus } from '../../../../../../pages/useAdministracion.hooks'
import { useBukSyncStatus } from '../../../../../../hooks/useBukSyncStatus'
import { notifyBukSyncCompleted, notifyBukSyncError } from '../../../../../../utils/bukSyncNotifications'
import { sileo } from 'sileo'
//import CustomPagination from '../../../../table/CustomPagination'
import LoaderAdm from '../../../../../../assets/svgIcons/LoaderAdm.json'
import Lottie from 'lottie-react'
import { useMediaQuery, Tooltip } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import PlanRestrictedButton from '../../../../ui/PlanRestrictedButton'
import { REACT_APP_RECONCILIATION_API_URL } from '../../../../../utils/constant'

const List = () => {
  const { currentBusiness } = useContext(GlobalContext)
  const businessAPI = useMemo(() => new BusinessAPI(), [])
  const integrationsAPI = useMemo(() => new IntegrationsAPI(), [])
  const { status: integrationStatus, setStatus } = useIntegrationStatus()
  const [data, setData] = useState([])
  const [isLoadingData, setIsLoadingData] = useState(true)
  const [isSyncingBuk, setIsSyncingBuk] = useState(false)
  const [isUpdatingReconciliation, setIsUpdatingReconciliation] = useState(false)
  const {
    syncStatus: bukSyncStatus,
    progress: bukSyncProgress,
    totalMonths: bukSyncTotalMonths,
    completedMonths: bukSyncCompletedMonths,
    startPolling: startBukSyncPolling
  } = useBukSyncStatus(currentBusiness?.id)
  const bukSyncToastIdRef = useRef(null)
  // Obtenemos primer y último día del mes actual
  const today = new Date()
  const mesActual = today.getMonth() + 1
  const añoActual = today.getFullYear()
  //const primerDiaMes = `${añoActual}-${String(mesActual).padStart(2, '0')}-01`
  const primerDiaMes = `${añoActual}-01-01`
  const primerDiaMesSiguiente = new Date(añoActual, mesActual, 1)
  const ultimoDiaDate = new Date(primerDiaMesSiguiente.getTime() - 24 * 60 * 60 * 1000)
  const ultimoDiaMes = `${ultimoDiaDate.getFullYear()}-${String(
    ultimoDiaDate.getMonth() + 1
  ).padStart(2, '0')}-${String(ultimoDiaDate.getDate()).padStart(2, '0')}`
  const [modalOpen, setModalOpen] = useState(false)
  const [modalBukOpen, setModalBukOpen] = useState(false)
  const [queryFrom, setQueryFrom] = useState(primerDiaMes) //
  const [queryTo, setQueryTo] = useState(ultimoDiaMes)
  const [rowsPerPage, setRowsPerPage] = useState(-1)
  const [searchText, setSearchText] = useState('')
  const [switchGetData, setSwitchGetData] = useState(false)
  const [order, setOrder] = useState({
    col: '',
    field: '',
    direction: 'asc'
  })
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const runReconciliationPipeline = async ({ businessId }) => {
    const params = new URLSearchParams({
      businessId: String(businessId),
      persist: 'true'
    })

    const response = await fetch(
      `${REACT_APP_RECONCILIATION_API_URL}/remuneraciones/conciliacion/run?${params.toString()}`,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json'
        }
      }
    )

    if (!response.ok) {
      throw new Error(
        `Error actualizando conciliaciones de remuneraciones: ${response.status}`
      )
    }

    return response.json()
  }

  const getData = async () => {
    const formatDateToMMYYYY = dateStr => {
      const [year, month] = dateStr.split('-')
      return `${month}-${year}`
    }
    try {
      const { data: responseData } = await businessAPI.getListWorker({
        businessId: currentBusiness.id,
        queryFrom: formatDateToMMYYYY(queryFrom),
        queryTo: formatDateToMMYYYY(queryTo)
      })

      const remunerationRows = Array.isArray(responseData)
        ? responseData
        : []
      
      setData(remunerationRows)
      
    } catch (error) {
      console.error(error)
      setData([])
    } finally {
      setIsLoadingData(false)
    }
  }

  const handleUpdateReconciliation = async () => {
    if (
      isUpdatingReconciliation ||
      !currentBusiness?.id
    ) {
      return
    }

    setIsUpdatingReconciliation(true)

    const toastId = sileo.show({
      title: 'Actualizando conciliaciones',
      description: 'Procesando remuneraciones y movimientos bancarios...',
      type: 'loading',
      duration: null
    })

    try {
      await runReconciliationPipeline({
        businessId: currentBusiness.id
      })

      sileo.dismiss(toastId)

      sileo.success({
        title: 'Conciliaciones actualizadas',
        description: 'La conciliación de remuneraciones fue recalculada correctamente.'
      })

      setSwitchGetData(true)
    } catch (error) {
      console.error(
        'Error actualizando conciliaciones de remuneraciones:',
        error
      )

      sileo.dismiss(toastId)

      sileo.error({
        title: 'Error al actualizar',
        description: 'No fue posible actualizar las conciliaciones de remuneraciones.'
      })
    } finally {
      setIsUpdatingReconciliation(false)
    }
  }

  useEffect(() => {
    setIsLoadingData(true)
    getData()
  }, [
    currentBusiness.id
  ])

  useEffect(() => {
    if (!switchGetData) return
    setIsLoadingData(true)
    getData()
    setSwitchGetData(false)
  }, [switchGetData])

  const handleFromChange = e => {
    const newFrom = e.target.value
    setQueryFrom(newFrom)
    if (newFrom > queryTo) {
      setQueryTo(newFrom)
    }
  }

  const handleToChange = e => {
    const newTo = e.target.value
    if (newTo < queryFrom) {
      setQueryTo(queryFrom)
    } else {
      setQueryTo(newTo)
    }
  }

  const handleSearchChange = e => setSearchText(e.target.value)

  const filteredData = Array.isArray(data)
    ? data.filter(
        item =>
          item.nombreTrabajador?.toLowerCase().includes(searchText.toLowerCase()) ||
          item.rutTrabajador?.toLowerCase().includes(searchText.toLowerCase())
      )
    : []

  // orden y paginación
  const handleSort = ({ col, field }) => {
    const asc = order.col === col && order.direction === 'asc'
    setOrder({ col, field, direction: asc ? 'desc' : 'asc' })
  }

  const handleBukButtonClick = async () => {
    if (isSyncingBuk) {
      sileo.warning({
        title: 'Sincronización en proceso',
        description: 'Espera a que termine para volver a sincronizar.'
      })
      return
    }

    const isBukIntegrated = integrationStatus?.buk?.integrated

    if (isBukIntegrated) {
      await handleBukSync()
    } else {
      setModalBukOpen(true)
    }
  }

  const dismissBukSyncToast = () => {
    if (bukSyncToastIdRef.current) {
      sileo.dismiss(bukSyncToastIdRef.current)
      bukSyncToastIdRef.current = null
    }
  }

  const handleBukSync = async () => {
    setIsSyncingBuk(true)
    bukSyncToastIdRef.current = sileo.show({
      title: 'Sincronizando',
      description: 'Conectando con Buk...',
      type: 'loading',
      duration: null
    })

    try {
      await integrationsAPI.syncBukIntegration(currentBusiness.id)
    } catch (error) {
      console.error('Error syncing with Buk:', error)
      dismissBukSyncToast()
      sileo.error({
        title: 'Error de Sincronización',
        description: 'Error al sincronizar con Buk 🤯'
      })
      setIsSyncingBuk(false)
      return
    }

    startBukSyncPolling({
      onCompleted: async data => {
        dismissBukSyncToast()
        notifyBukSyncCompleted(data)
        try {
          const { data: freshStatus } = await integrationsAPI.getIntegrationsStatus(currentBusiness.id)
          setStatus(freshStatus)
        } catch (err) {
          console.error('Error refreshing integration status:', err)
        }
        setIsSyncingBuk(false)
        setSwitchGetData(true)
      },
      onError: data => {
        dismissBukSyncToast()
        notifyBukSyncError(data)
        setIsSyncingBuk(false)
      }
    })
  }

  useEffect(() => {
    if (!isSyncingBuk || bukSyncStatus !== 'processing' || bukSyncTotalMonths === 0) return
    dismissBukSyncToast()
    bukSyncToastIdRef.current = sileo.show({
      title: 'Sincronizando',
      description: `${bukSyncCompletedMonths}/${bukSyncTotalMonths} meses completados (${bukSyncProgress}%)`,
      type: 'loading',
      duration: null
    })
  }, [bukSyncStatus, bukSyncProgress, bukSyncTotalMonths, bukSyncCompletedMonths])

  const bukButtonTitle = isSyncingBuk
    ? 'SINCRONIZACIÓN EN PROCESO'
    : integrationStatus?.buk?.integrated ? 'SINCRONIZAR BUK' : 'CONECTAR CON BUK'

  const formatLastSyncTime = lastSyncAt => {
    if (!lastSyncAt) return null
    try {
      const syncDate = new Date(lastSyncAt)
      const today = new Date()
      const timeZone = 'America/Santiago'
      const getParts = date =>
        Object.fromEntries(
          new Intl.DateTimeFormat('es-CL', {
            timeZone,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            weekday: 'long',
            hourCycle: 'h23',
          }).formatToParts(date).map(p => [p.type, p.value])
        )
      const syncParts = getParts(syncDate)
      const todayParts = getParts(today)
      const time = `${syncParts.hour}:${syncParts.minute}`
      if (syncParts.day === todayParts.day && syncParts.month === todayParts.month && syncParts.year === todayParts.year) {
        return `Hoy a las ${time}`
      }
      const dayName = syncParts.weekday.charAt(0).toUpperCase() + syncParts.weekday.slice(1)
      return `${dayName} ${syncParts.day}/${syncParts.month}/${syncParts.year} a las ${time}`
    } catch (error) {
      return null
    }
  }
  const lastSyncTime = integrationStatus?.buk?.lastSyncAt
    ? formatLastSyncTime(integrationStatus.buk.lastSyncAt)
    : null

  return (
    <>
      <div
        className='p-4 mt-6 bg-white rounded-3xl shadow-md flex flex-col'
        style={{ height: isMobile ? 'auto' : 'calc(100vh - 12rem)' }}
      >
          <div className='flex flex-wrap gap-4 mt-1 items-end rounded-3xl p-6 mb-4'>
            <div className='flex flex-col'>
              <label className='text-xs mb-1 font-sans font-medium'>Fecha Desde</label>
              <input
                type='date'
                value={queryFrom}
                onChange={handleFromChange}
                max={queryTo}
                className='min-w-[140px] border border-gray-300 rounded-full px-2 py-1 text-sm font-sans'
              />
            </div>
            <div className='flex flex-col'>
              <label className='text-xs mb-1 font-sans font-medium'>Fecha Hasta</label>
              <input
                type='date'
                value={queryTo}
                onChange={handleToChange}
                min={queryFrom}
                className='min-w-[140px] border border-gray-300 rounded-full px-2 py-1 text-sm font-sans'
              />
            </div>
            <div className='flex flex-col'>
              <SearchFilter value={searchText} onChange={handleSearchChange} />
            </div>
            <div className='flex flex-col items-end'>
              <CustomButton
                className='rounded-full'
                color='primary'
                title='BUSCAR'
                onClick={getData}
              />
            </div>
            <div className='flex flex-col items-end'>
              <Button
                className='rounded-full px-2 py-1 bg-accent2 text-white text-sm font-sans'
                title='CARGAR REMUNERACIÓN'
                onClick={() => setModalOpen(true)}
              />
            </div>
            {currentBusiness?.conciliacionAutomatica && (
              <div className='flex flex-col items-end'>
                <Button
                  className='rounded-full px-2 py-1 bg-accent2 text-white text-sm font-sans'
                  title={
                    isUpdatingReconciliation
                      ? 'ACTUALIZANDO...'
                      : 'ACTUALIZAR CONCILIACIONES'
                  }
                  onClick={handleUpdateReconciliation}
                  disabled={isUpdatingReconciliation}
                />
              </div>
            )}
            <div className='flex flex-col items-center'>
              {integrationStatus?.buk?.integrated && lastSyncTime && (
                <span className='text-xs text-gray-500 whitespace-nowrap mb-1 text-center'>
                  Última vez sincronizado: {lastSyncTime}
                </span>
              )}
              <div className='flex items-center gap-1'>
                <PlanRestrictedButton
                  keepEnabled={true}
                  requiredPermission="allowBukIntegration"
                  message="La integración con BUK no está disponible en tu plan actual. Actualiza tu plan para acceder a esta funcionalidad."
                >
                  <Button
                    className='rounded-full px-2 py-1 bg-accent2 text-white text-sm font-sans'
                    title={bukButtonTitle}
                    onClick={handleBukButtonClick}
                    disabled={isSyncingBuk}
                  />
                </PlanRestrictedButton>
                {isSyncingBuk && (
                  <Tooltip
                    arrow
                    title={
                      bukSyncTotalMonths > 0
                        ? `Procesando mes ${Math.min(bukSyncCompletedMonths + 1, bukSyncTotalMonths)}/${bukSyncTotalMonths} (${bukSyncProgress}%)`
                        : 'Conectando con Buk...'
                    }
                  >
                    <span className='flex items-center justify-center w-5 h-5 rounded-full border border-gray-400 text-gray-500 text-xs font-bold cursor-help select-none'>
                      ?
                    </span>
                  </Tooltip>
                )}
              </div>
            </div>
          </div>
        
        {isLoadingData ? (
          <div className='flex items-center justify-center h-full'>
            <Lottie animationData={LoaderAdm} loop style={{ width: 300, height: 300 }} />
          </div>
        ) : (
          <>
            <TableRemuneracion
              rows={filteredData}
              allRows={data}
              onSort={handleSort}
              order={order}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              setSwitchGetData={setSwitchGetData}
            />
            {/* {(paginatedData.length > 0) && (
          <div className="mt-4">
            <CustomPagination
              count={filteredData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </div>
        )}*/}
          </>
        )}
      </div>
      {modalOpen && (
        <ModalAgregarRemuneracion
          open={modalOpen}
          setOpen={setModalOpen}
          setSwitchGetData={setSwitchGetData}
        />
      )}
      {modalBukOpen && (
        <ModalConectarBuk
          open={modalBukOpen}
          setOpen={setModalBukOpen}
          onIntegrationComplete={() => setSwitchGetData(true)}
        />
      )}
    </>
  )
}

export default List
